import React from "react";
import { Page } from "@sscs/ui";
import { PROFILE_ROUTE, USER_SETTINGS_ROUTE } from "Constants";
import { useLoginInfo, useRedirect } from "Hooks";
import ChangePasswordForm from "../../components/ChangePasswordForm/ChangePasswordForm";

const ChangePassword = () => {
  const { hasLoaded, isSSOLogin } = useLoginInfo();

  useRedirect({
    to: `/${USER_SETTINGS_ROUTE}/${PROFILE_ROUTE}`,
    when: hasLoaded && isSSOLogin,
  });

  return (
    <Page.Root>
      <Page.Header title="Change password" />
      <Page.Body status={hasLoaded ? undefined : { status: "LOADING" }}>
        <ChangePasswordForm />
      </Page.Body>
    </Page.Root>
  );
};

export default ChangePassword;
